import { Box } from '@mui/material';
import PageContainer from '../layout/PageContainer';

export default function Home() {
  return <PageContainer
    title="Home"
  >
    <Box sx={{ minHeight: '35vh' }}>
    </Box>
  </PageContainer>
}
